module.exports = __webpack_public_path__ + "media/images/story/icon/balloon-icon-879b8a1b462aa56c3490ab789c1a5ce2.png";